/* tooltip-container.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDzXzM%7Bborder-radius%3Avar(--ds-radius-small%2C3px)%7D%0A._2sNsIg7NXe%7Bfont%3Avar(--ds-font-body-small%2Cnormal%20400%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D%0A._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D%0A._1EqgXlGVdc%7Bmax-width%3A15pc%7D%0A._0KLXrugozt%7Bbackground-color%3Avar(--ds-background-neutral-bold%2C%23292a2e)%7D%0A._1UtDYze5R3%7Bcolor%3Avar(--ds-text-inverse%2C%23fff)%7D%0A._2I62gzPgdg%7Binset-block-start%3Avar(--ds-space-0%2C0)%7D%0A._3iC0zdPgdg%7Binset-inline-start%3Avar(--ds-space-0%2C0)%7D%0A._3zvHkHwPeg%7Boverflow-wrap%3Abreak-word%7D%0A._46hvQm1Y8M%7Bpadding-block-start%3Avar(--ds-space-050%2C4px)%7D%0A._0xmtko1Y8M%7Bpadding-block-end%3Avar(--ds-space-050%2C4px)%7D%0A._03SyCPgVvo%7Bpadding-inline-end%3Avar(--ds-space-075%2C6px)%7D%0A._0LQT5EgVvo%7Bpadding-inline-start%3Avar(--ds-space-075%2C6px)%7D%0A._1T2N03wPeg%7Bword-wrap%3Abreak-word%7D%0A._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D%0A._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D%0A._1EqgXlgs9g%7Bmax-width%3A420px%7D%0A._39HuIbz8Lp%7Btext-overflow%3Aellipsis%7D%0A._1ANEUSLRg7%7Bwhite-space%3Anowrap%7D");


















import { forwardRef } from 'react';
import TooltipPrimitive, { type TooltipPrimitiveProps } from './tooltip-primitive';
export interface TooltipContainerProps extends TooltipPrimitiveProps {}
const styles = {
  base: "_0bjKvDzXzM _2sNsIg7NXe _24h04i2Njc _1EqgXlGVdc _0KLXrugozt _1UtDYze5R3 _2I62gzPgdg _3iC0zdPgdg _3zvHkHwPeg _46hvQm1Y8M _0xmtko1Y8M _03SyCPgVvo _0LQT5EgVvo _1T2N03wPeg",
  truncate: "_4bt5LAnQyn _2WAcuGnQyn _1EqgXlgs9g _39HuIbz8Lp _1ANEUSLRg7"
};

/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */
const TooltipContainer: React.ForwardRefExoticComponent<React.PropsWithoutRef<TooltipContainerProps> & React.RefAttributes<HTMLDivElement>> = forwardRef<HTMLDivElement, TooltipContainerProps>(function TooltipContainer({
  style,
  className,
  children,
  truncate,
  placement,
  testId,
  onMouseOut,
  onMouseOver,
  id,
  shortcut,
  role
}, ref) {
  return <TooltipPrimitive ref={ref} style={style}
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
  className={ax([styles.base, truncate && styles.truncate, className])} placement={placement} testId={testId} id={id} onMouseOut={onMouseOut} onMouseOver={onMouseOver} shortcut={shortcut} role={role}>
			{children}
		</TooltipPrimitive>;
});
TooltipContainer.displayName = 'TooltipContainer';
export default TooltipContainer;